module.exports = __webpack_public_path__ + "static/media/3.2775f732.jpg";